module.exports = __webpack_public_path__ + "static/assets/80b74cbb5c71dd296d860f8b82ae23e5.svg";